import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { Colors } from '@zapier/design-system';
import InAppLinks from './InAppLinks';
import OutOfAppLinks from './OutOfAppLinks';
import { UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH, UNIVERSAL_SIDEBAR_WIDTH, } from '../../constants';
import { useQuerySidebar } from '../../hooks';
const GAP = 20;
const Styles = labelStyles('UniversalSidebar', {
    root: ({ isCollapsed, isFullWidth, isShadowed, }) => [
        {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: Colors.neutral100,
            padding: '30px 10px 0 10px',
            willChange: 'transform, width',
        },
        !isFullWidth &&
            withModifier('constrainedWidth', {
                width: UNIVERSAL_SIDEBAR_WIDTH,
                maxWidth: '100vw',
            }),
        !isFullWidth &&
            withModifier('bordered', {
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    width: 1,
                    backgroundColor: Colors.gray20,
                },
            }),
        isShadowed &&
            withModifier('shadowed', {
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    bottom: 0,
                    width: 10,
                    pointerEvents: 'none',
                    background: `linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.10) 0%,
            rgba(0, 0, 0, 0.03) 50%,
            rgba(0, 0, 0, 0.00) 100%
          )`,
                },
            }),
        isCollapsed &&
            withModifier('collapsed', {
                width: UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH,
                overflow: 'visible',
            }),
    ],
    header: {
        flex: 'none',
    },
    content: ({ isCollapsed }) => [
        {
            overflow: 'auto',
            paddingTop: GAP,
            paddingBottom: GAP,
            flexBasis: 'auto',
            flexShrink: 1,
            flexGrow: 0,
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': {
                display: 'none',
            },
        },
        isCollapsed &&
            withModifier('collapsed', {
                overflow: 'visible',
            }),
    ],
    links: ({ isCollapsed }) => [
        Object.assign({ alignContent: 'start', display: 'grid', gap: 10, listStyle: 'none' }, (!isCollapsed && { padding: '0 2px' })),
    ],
    footer: {
        flex: 'none',
        borderTop: `1px solid ${Colors.neutral300}`,
        paddingTop: GAP,
        paddingBottom: GAP,
    },
});
const UniversalSidebar = ({ isCollapsed = false, isFullWidth = true, isShadowed, links, onClick, onMouseEnter, onMouseLeave, renderFooter = () => null, renderSubheader, selectedHref = '', }) => {
    const { sideNavData } = useQuerySidebar();
    const mouseProps = {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
    };
    const subheaderContent = renderSubheader && renderSubheader();
    const subheader = subheaderContent && (isolateComponent("div", { css: Styles.header }, subheaderContent));
    const footerContent = renderFooter();
    const footer = footerContent && (isolateComponent("div", { css: Styles.footer, role: "region" }, footerContent));
    return (isolateComponent("nav", Object.assign({ "aria-label": "Site Links", css: Styles.root({ isCollapsed, isFullWidth, isShadowed }), "data-testid": "universalSidebar" }, mouseProps),
        subheader,
        isolateComponent("div", { css: Styles.content({ isCollapsed }) },
            isolateComponent("ul", { css: Styles.links({ isCollapsed }) }, links ? (isolateComponent(OutOfAppLinks, { isCollapsed: isCollapsed, navigationItems: links })) : (isolateComponent(InAppLinks, { isCollapsed: isCollapsed, links: sideNavData, selectedHref: selectedHref })))),
        footer));
};
export default UniversalSidebar;
//# sourceMappingURL=UniversalSidebar.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
